import { render, staticRenderFns } from "./ChatbotSupportAverageTimeChart.vue?vue&type=template&id=42649806"
import script from "./ChatbotSupportAverageTimeChart.vue?vue&type=script&lang=js"
export * from "./ChatbotSupportAverageTimeChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSupportAverageTimeChart.vue?vue&type=style&index=0&id=42649806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports